"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkExport = exports.isExport = void 0;
const __1 = require("..");
function isExport(object) {
    return checkExport(object).fulfilled;
}
exports.isExport = isExport;
function checkExport(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasNumber)("requestTime").integer(), (0, __1.hasString)("userId"), (0, __1.hasChoice)("resourceType", ["project", "times"]), (0, __1.hasString)("resourceId"), (0, __1.hasString)("format"), (0, __1.hasMap)("filter", (0, __1.isAny)()), (0, __1.hasChoice)("state", ["requested", "in-progress", "failed", "errored", "complete", "canceled", "deleted"]), (0, __1.hasString)("fileName").nonEmpty().optional(), (0, __1.hasString)("location").nonEmpty().optional()).withOptions(options).explain();
}
exports.checkExport = checkExport;
//# sourceMappingURL=Export.js.map